import { css } from 'lit';

var css_248z = css`.datepicker-header{padding:1.5rem 1.5rem 0}.datepicker-header,.datepicker-header button{border:none;color:var(--datepicker-theme-color)}.datepicker-header button{background-color:transparent;cursor:pointer;font-weight:700}.datepicker-header button:focus{outline:var(--datepicker-theme-color) auto 2px}.datepicker-header button.disabled{cursor:not-allowed}.datepicker-header button:hover:not(.disabled){background-color:var(--datepicker-hover-bg-color)}.datepicker-header svg{font-size:10rem}`;

export { css_248z as default };
//# sourceMappingURL=datepicker-header2.js.map
